/**
 * @generated SignedSource<<06d403dda8812ac603e97481097a385c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CourseBucketFilterControlFragment_facility$data = {
  readonly copyOverrides: {
    readonly course: {
      readonly singular: string;
    } | null | undefined;
  };
  readonly courseBuckets: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "CourseBucketFilterControlFragment_facility";
};
export type CourseBucketFilterControlFragment_facility$key = {
  readonly " $data"?: CourseBucketFilterControlFragment_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"CourseBucketFilterControlFragment_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CourseBucketFilterControlFragment_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CourseBucketConnection",
      "kind": "LinkedField",
      "name": "courseBuckets",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CourseBucketEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CourseBucket",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FacilityCopyOverrides",
      "kind": "LinkedField",
      "name": "copyOverrides",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NounOverride",
          "kind": "LinkedField",
          "name": "course",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "singular",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "a7aef57e8c97318c57b7b583ff65f4f4";

export default node;
